import { useMemo } from "react";

import { selectPoiCategories } from "@/features/app/appSlice";

import { useAppSelector } from "@/app/hooks";
import { selectCurrentBuilding } from "@/features/cartography/cartographySlice.selectors";
import { filterCategoriesWithExistingPOIs } from "@/features/explorer_panel/poi_category_list/utils";

export default function usePOICategoriesOnBuilding(
  params: { keepTopLevels?: boolean } = { keepTopLevels: true },
) {
  const currentBuilding = useAppSelector(selectCurrentBuilding);
  const poiCategories = useAppSelector(selectPoiCategories);
  const poiCategoriesInBuilding = useMemo(() => {
    return filterCategoriesWithExistingPOIs(
      poiCategories,
      currentBuilding?.pois,
      params.keepTopLevels,
    );
  }, [poiCategories, currentBuilding?.pois, params.keepTopLevels]);
  return poiCategoriesInBuilding;
}
